import {
  IonButton,
  IonButtons,
  IonFab,
  IonFabButton,
  IonFabList,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonSelect,
  IonSelectOption,
  IonText,
  useIonToast,
} from "@ionic/react";
import {
  chevronUpCircleOutline,
  shareSocialOutline,
  printOutline,
  mapOutline,
  save,
  createOutline,
} from "ionicons/icons";
import { format } from "date-fns";
import { id as indo } from "date-fns/locale";
import React, { useEffect, useState } from "react";
import { useDocument, useCollection } from "react-firebase-hooks/firestore";
import { useFirebase } from "../firebase-provider";
import PageLayout from "../layout";
import Loading from "../loading";
import hitungSablon from "../../utils/harga-sablon";
import receipt from "./receipt";
import address from "./address";
import QRCode from "qrcode";
import s from "./style.module.css";

const DetailTransaction = ({ match }) => {
  const id = match.params.id;
  const [toast] = useIonToast();
  const initDataPesanan = {
    id: id,
    pesanan: [{ id: "123", produk: {}, jasa: {}, isJasa: false }],
    detail: {
      nama: "",
      kontak: "",
      alamat: "",
    },
    pembayaran: {
      total: 0,
      dibayar: 0,
      akun: "",
      dikonfirmasi: false,
    },
    pengiriman: {
      jenis: "COD",
      biaya: 0,
    },
    status: "dibuat",
    riwayat: [],
  };

  const [dataPesanan, setDataPesanan] = useState(initDataPesanan);
  const [status, setStatus] = useState(dataPesanan?.status);
  const [pembayaran, setPembayaran] = useState(dataPesanan?.pembayaran);
  const { firestore } = useFirebase();
  const [snapshots, loading] = useDocument(firestore.doc("transaksi/" + id));
  const [snapshotsRekening, loadingRekening] = useCollection(
    firestore.collection("/data/keuangan/akun")
  );

  useEffect(() => {
    if (snapshots) {
      setDataPesanan(snapshots.data());
      setStatus(snapshots.data()?.status);
      setPembayaran(snapshots.data()?.pembayaran);
    }
  }, [snapshots]);

  // Total
  const total_dibayar = dataPesanan?.pesanan
    ?.map((psn) => {
      const _total = Object.keys(psn.produk)
        .map((el) => {
          const _sablon = Object.keys(psn.jasa)
            .map((s) => hitungSablon(psn.jasa[s].panjang, psn.jasa[s].lebar))
            .reduce((a, b) => a + b, 0);
          const _data = psn.produk[el];
          const _harga = Number(_data.harga) + Number(_sablon);
          return (Number(_harga || 0) - _data.potongan) * _data.jumlah;
        })
        .reduce((c, d) => c + d, 0);
      return _total;
    })
    .reduce((c, d) => c + d, 0);

  // Update

  const updateStatus = async (el) => {
    await firestore
      .collection("transaksi")
      .doc(id)
      .update({
        status: status,
        riwayat: [
          ...dataPesanan?.riwayat,
          { status: status, waktu: new Date() },
        ],
      })
      .then(() => {
        toast({
          message: "Status berhasil diperbarui!",
          duration: 3000,
          color: "success",
          position: "top",
        });
      })
      .catch(() => {
        toast({
          message: "Status gagal diperbarui!",
          duration: 3000,
          color: "danger",
          position: "top",
        });
      });
  };

  // DATA RAW PRINT

  // QR
  const [qr, setqr] = useState("");

  QRCode.toString("https://invoice.tapakindustries.com/" + id).then((val) =>
    setqr(val)
  );

  const buttons = (
    <>
      <IonButton routerLink={"/app/transaction/edit/" + id} size="large">
        <IonIcon icon={createOutline} />
      </IonButton>
    </>
  );

  return (
    <PageLayout title={`Transaksi ${id}`} buttons={buttons}>
      {loading && loadingRekening && <Loading />}
      {snapshots && !loading && !loadingRekening && (
        <IonList>
          <IonItem lines="full">
            <IonLabel className={s.label} slot="start" color="medium">
              Pemesan
            </IonLabel>
            <IonLabel className="ion-text-wrap">
              {dataPesanan?.detail?.nama}
            </IonLabel>
          </IonItem>

          <IonItem lines="full">
            <IonLabel className={s.label} slot="start" color="medium">
              Alamat
            </IonLabel>
            <IonLabel className="ion-text-wrap">
              <p>{dataPesanan?.detail?.alamat || "-"}</p>
            </IonLabel>
          </IonItem>

          <IonItem lines="full">
            <IonLabel className={s.label} slot="start" color="medium">
              Kontak
            </IonLabel>
            <IonLabel className="ion-text-wrap">
              <p>{dataPesanan?.detail?.kontak || "-"}</p>
            </IonLabel>
          </IonItem>

          <IonItem lines="full">
            <IonLabel className={s.label} slot="start" color="medium">
              ID Transaksi
            </IonLabel>
            <IonLabel className="ion-text-wrap">
              <p>{id}</p>
            </IonLabel>
          </IonItem>

          <IonItem lines="full">
            <IonLabel className={s.label} slot="start" color="medium">
              Admin
            </IonLabel>
            <IonLabel className="ion-text-wrap">
              <p>{dataPesanan?.admin || "-"}</p>
            </IonLabel>
          </IonItem>

          <IonItem lines="full">
            <IonLabel className={s.label} slot="start" color="medium">
              Status
            </IonLabel>

            <IonSelect
              className={s.select}
              cancelText="Batal"
              value={status}
              color="success"
              onIonChange={(e) => setStatus(e.detail.value)}
            >
              <IonSelectOption value="Dibuat">Dibuat</IonSelectOption>
              <IonSelectOption value="Dibayar">Dibayar</IonSelectOption>
              <IonSelectOption value="Diproses">Diproses</IonSelectOption>
              <IonSelectOption value="Siap">Siap</IonSelectOption>
              <IonSelectOption value="Dikirim">Dikirim</IonSelectOption>
              <IonSelectOption
                disabled={
                  dataPesanan?.pembayaran?.dibayar <
                  dataPesanan?.pembayaran?.total
                }
                value="Selesai"
              >
                Selesai
              </IonSelectOption>
            </IonSelect>

            {dataPesanan?.status !== status && (
              <IonButtons slot="end">
                <IonButton color="primary" size="large" onClick={updateStatus}>
                  <IonIcon icon={save}></IonIcon>
                </IonButton>
              </IonButtons>
            )}
          </IonItem>

          {dataPesanan?.pesanan?.map((psn, index) => {
            return (
              <React.Fragment key={psn.id}>
                <IonListHeader color="light">
                  <strong>Pesanan {index + 1}</strong>
                </IonListHeader>

                {Object.keys(psn.produk).map((p) => {
                  const data = psn.produk[p];

                  const biaya_sablon = Object.keys(psn.jasa)
                    .map((s) =>
                      hitungSablon(psn.jasa[s].panjang, psn.jasa[s].lebar)
                    )
                    .reduce((a, b) => a + b, 0);

                  const harga_akhir = Number(data.harga) + Number(biaya_sablon);
                  return (
                    <React.Fragment key={p}>
                      <IonItem lines="full">
                        <IonLabel slot="start">
                          {data.nama} ({data.data.warna}, {data.data.ukuran})
                          <IonText color="medium">
                            <p>{data.merk}</p>
                          </IonText>
                          <IonText
                            color={
                              Number(data.potongan || 0) === 0
                                ? `success`
                                : `warning`
                            }
                          >
                            <p>
                              @
                              {new Intl.NumberFormat("id-ID", {
                                style: "currency",
                                currency: "IDR",
                                maximumSignificantDigits: 10,
                              }).format(
                                Number(harga_akhir || 0) -
                                  Number(data.potongan || 0)
                              )}
                            </p>
                          </IonText>
                          <IonText color="danger">
                            <p>
                              -
                              {new Intl.NumberFormat("id-ID", {
                                style: "currency",
                                currency: "IDR",
                                maximumSignificantDigits: 10,
                              }).format(Number(data.potongan || 0))}
                            </p>
                          </IonText>
                        </IonLabel>
                        <IonLabel>
                          <p>x {data.jumlah}</p>
                        </IonLabel>
                        <IonLabel color="success" className="ion-text-right">
                          <p>
                            {new Intl.NumberFormat("id-ID", {
                              style: "currency",
                              currency: "IDR",
                              maximumSignificantDigits: 10,
                            }).format(
                              (Number(harga_akhir || 0) - data.potongan) *
                                data.jumlah
                            )}
                          </p>
                        </IonLabel>
                      </IonItem>
                    </React.Fragment>
                  );
                })}

                {psn.isJasa && (
                  <>
                    <IonListHeader>
                      <strong>Sablon:</strong>
                    </IonListHeader>
                    {Object.keys(psn.jasa).map((j) => {
                      const data = psn.jasa[j];
                      return (
                        <React.Fragment key={j}>
                          <IonItem lines="full">
                            <IonLabel slot="start">{data.posisi}</IonLabel>
                            <IonLabel>
                              <p>
                                {data.panjang} cm x {data.lebar} cm
                              </p>
                            </IonLabel>
                            <IonLabel
                              color="success"
                              className="ion-text-right"
                            >
                              <p>
                                {new Intl.NumberFormat("id-ID", {
                                  style: "currency",
                                  currency: "IDR",
                                  maximumSignificantDigits: 10,
                                }).format(
                                  hitungSablon(data.panjang, data.lebar)
                                )}
                              </p>
                            </IonLabel>
                          </IonItem>
                        </React.Fragment>
                      );
                    })}
                  </>
                )}
              </React.Fragment>
            );
          })}

          <IonListHeader color="medium">Informasi Pembayaran</IonListHeader>
          <IonItem color="light">
            <IonLabel className={s.label} slot="start" color="medium">
              Rek. Pembayaran
            </IonLabel>
            <IonSelect
              className={s.select}
              placeholder="Rekening Pembayaran"
              disabled={dataPesanan?.pembayaran?.dikonfirmasi}
              value={pembayaran?.akun}
              onIonChange={(el) =>
                setPembayaran({ ...pembayaran, akun: el.detail.value })
              }
            >
              {snapshotsRekening?.docs?.map((doc) => (
                <React.Fragment key={doc.id}>
                  <IonSelectOption value={doc.id}>
                    {doc?.data()?.jenis === "cash"
                      ? `Kas ${doc?.data()?.nama}`
                      : `${doc?.data()?.bank} (${doc?.data()?.nama})`}
                  </IonSelectOption>
                </React.Fragment>
              ))}
            </IonSelect>
          </IonItem>

          <IonItem lines="full" color="light">
            <IonLabel className={s.label} slot="start" color="medium">
              Total
            </IonLabel>
            <IonText className="ion-padding-bottom ion-padding-top">
              {new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                maximumSignificantDigits: 10,
              }).format(total_dibayar)}
            </IonText>
          </IonItem>

          <IonItem color="light">
            <IonLabel className={s.label} slot="start" color="medium">
              Dibayar
            </IonLabel>
            <IonLabel className={s.rp} position="fixed">
              Rp
            </IonLabel>
            <IonInput
              className={s.select}
              type="number"
              value={pembayaran?.dibayar}
              onIonChange={(el) =>
                setPembayaran({
                  ...pembayaran,
                  dibayar: Number(el.detail.value),
                })
              }
            />

            {dataPesanan?.pembayaran?.dibayar !== pembayaran?.dibayar &&
              pembayaran?.akun !== "" && (
                <IonButtons slot="end">
                  <IonButton
                    color="primary"
                    size="large"
                    onClick={async () => {
                      var initPemasukanData = {
                        nama: "Transaksi " + id,
                        akun: pembayaran.akun,
                        waktu: format(new Date(), "yyyy-MM-dd'T'HH:mmXXX"),
                        jumlah: pembayaran.dibayar,
                        catatan: "Di input oleh sistem",
                        timestamp: new Date(),
                      };

                      var kasAkunObj = Object.fromEntries(
                        new Map(
                          snapshotsRekening?.docs?.map((doc) => [
                            doc.id,
                            doc.data(),
                          ])
                        )
                      );

                      const updateRekening = firestore
                        .collection("/data/keuangan/akun")
                        .doc(pembayaran.akun)
                        .update({
                          saldo:
                            Number(kasAkunObj[pembayaran.akun]?.saldo || 0) -
                            Number(dataPesanan?.pembayaran?.dibayar || 0) +
                            Number(pembayaran.dibayar || 0),
                        });

                      const InputPemasukan = !dataPesanan?.pembayaran
                        ?.dikonfirmasi
                        ? firestore
                            .collection("/data/keuangan/pemasukan")
                            .doc(id)
                            .set(initPemasukanData)
                        : firestore
                            .collection("/data/keuangan/pemasukan")
                            .doc(id)
                            .update(initPemasukanData);

                      const updateTransaksi = firestore
                        .collection("/transaksi/")
                        .doc(id)
                        .update({
                          pembayaran: { ...pembayaran, dikonfirmasi: true },
                        });

                      await Promise.all([
                        InputPemasukan,
                        updateTransaksi,
                        updateRekening,
                      ])
                        .then(() => {
                          toast({
                            message: "Pembayaran berhasil diupdate!",
                            duration: 3000,
                            color: "success",
                            position: "top",
                          });
                        })
                        .catch(() => {
                          toast({
                            message: "Terjadi kesalahan jaringan!",
                            duration: 3000,
                            color: "danger",
                            position: "top",
                          });
                        });
                    }}
                  >
                    <IonIcon icon={save}></IonIcon>
                  </IonButton>
                </IonButtons>
              )}
          </IonItem>

          <IonItem lines="full" color="light">
            <IonLabel className={s.label} slot="start" color="medium">
              Tersisa
            </IonLabel>
            <IonText className="ion-padding-bottom ion-padding-top">
              {new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                maximumSignificantDigits: 10,
              }).format(
                Number(total_dibayar) - Number(dataPesanan?.pembayaran?.dibayar)
              )}
            </IonText>
          </IonItem>

          <IonListHeader color="medium">Riwayat Transaksi</IonListHeader>
          {dataPesanan?.riwayat?.map((hs) => {
            let status = "";
            switch (hs.status) {
              case "Dibuat":
                status = "Pesanan dibuat";
                break;
              case "Dibayar":
                status = "Pesanan telah dibayar";
                break;
              case "Dikonfirmasi":
                status = "Pembayaran dikonfirmasi";
                break;
              case "Diproses":
                status = "Pesanan diproses";
                break;
              case "Siap":
                status = "Pesanan telah siap dikirim/dijemput";
                break;
              case "Dikirim":
                status = "Pesanan dalam proses pengiriman";
                break;
              case "Selesai":
                status = "Pesanan telah selesai";
                break;
              default:
                status = "";
                break;
            }
            return (
              <React.Fragment key={hs.waktu}>
                <IonItem color="light" lines="full">
                  <IonLabel slot="start" color="medium" className={s.label}>
                    {format(hs?.waktu?.toDate(), "hh:mm - dd MMMM yyyy", {
                      locale: indo,
                    })}
                  </IonLabel>
                  <IonLabel>{status}</IonLabel>
                </IonItem>
              </React.Fragment>
            );
          })}
        </IonList>
      )}

      <IonFab vertical="bottom" horizontal="end" slot="fixed">
        <IonFabButton color="secondary">
          <IonIcon icon={chevronUpCircleOutline} />
        </IonFabButton>
        <IonFabList side="top">

        <IonFabButton onClick={() => {
    if (navigator.share) {
      navigator.share({
        title: `TRANSAKSI ${id}`,
        text: "Klik link untuk melihat faktur pembelian anda di Tapak Industries",
        url: `https://invoice.tapakindustries.com/${id}`,
      })
    } else {
      window.open(
        `https://invoice.tapakindustries.com/${id}`
      )
    }
  }}>
            <IonIcon icon={shareSocialOutline} />
          </IonFabButton>

          <IonFabButton
            onClick={() => {
              let myWindow = window.open("", `TRANSAKSI ${id}`);
              myWindow.document.write(receipt(dataPesanan, total_dibayar, qr));

              myWindow.print();
            }}
          >
            <IonIcon icon={printOutline} />
          </IonFabButton>

          <IonFabButton
            onClick={() => {
              let myWindow = window.open("", `Alamat ${id}`);
              myWindow.document.write(address(dataPesanan));
              myWindow.print();
            }}
          >
            <IonIcon icon={mapOutline} title="Print Alamat" />
          </IonFabButton>


        </IonFabList>
      </IonFab>
    </PageLayout>
  );
};

export default DetailTransaction;
